export default "__VITE_ASSET__922fcaa1__"